import type {DataObject, ImageFormat} from "@cm/utils"
import {extensionForContentType} from "@cm/utils"
import type {DataObjectWithRelated, ThumbnailResolution} from "@cm/utils/data-object"
import type {CmLogger} from "@cm/log"

export function getDataObjectFromImageResourceForFormatAndResolution(
    resolvedResource: DataObjectWithRelated,
    format: ImageFormat,
    resolution: ThumbnailResolution,
    logger: CmLogger,
): DataObject {
    if (extensionForContentType(resolvedResource.mediaType) === format && resolution === "original") {
        return resolvedResource
    }

    const matchSize = (dataObject: DataObject) => {
        if (resolution === "original") return dataObject.width === resolvedResource.width && dataObject.height === resolvedResource.height

        const parsedResolution = parseInt(dataObject.downloadUrl.slice(dataObject.downloadUrl.lastIndexOf("-") + 1))
        return `${dataObject.width}px` === resolution || `${dataObject.height}px` === resolution || `${parsedResolution}px` === resolution
    }

    const matchedDataObject = resolvedResource.related?.find((dataObject) => extensionForContentType(dataObject.mediaType) === format && matchSize(dataObject))
    if (matchedDataObject) return matchedDataObject

    logger.warn(
        `Could not find related data object for format ${format} and resolution ${resolution} in resolved resource, returning original data object`,
        resolvedResource,
    )
    return resolvedResource
}
